<template>
    <div class="loader">
        <figure class="logo">
            <img src="../assets/img/hiq-logo.svg" alt="HiQ">
        </figure>
    </div>
</template>

<script>
    export default {
        name: 'loader'
    }
</script>

<style scoped>
    .loader {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue